import { Row, Tabs } from "antd";
import React, { useEffect } from "react";
import "../../assets/style/pageStyle/store.scss";
import TableStore from "../../components/common/Table/TableStore";
import { useDispatch, useSelector } from "react-redux";
import {
  confirmStoreStatus,
  deleteProduct,
  resetState,
  resetStatus,
  setOpenModalGetLogStore,
} from "../../services/slice/StoreSlice";
import {
  pupSelector,
  storeProductSelector,
} from "../../services/selector/index.";
import Notify from "../../components/common/Notify";
import { setOpenPUDelete } from "../../services/slice/PopUpSlice";
import { useTranslation } from "react-i18next";
import TranslateText from "../../components/common/TranslateText";
import { useState } from "react";
import TableConfigPageOneStore from "../../components/common/Table/TableConfigPageOneStore";
import ModalPreviewProduct from "../../components/common/Modal/getDetail/ModalPreviewProduct";
import ModalAddProduct from "../../components/common/Modal/add/ModalAddProduct";
import ModalEditProduct from "../../components/common/Modal/edit/ModalEditProduct";
import ModalConfirmStoreStatus from "../../components/common/Modal/other/ModalConfirmStoreStatus";
import ModalDelete from "../../components/common/Modal/delete/ModalDelete";
import ModalGetLog from "../../components/common/Modal/getLog/ModalGetLog";
const StoreManager = () => {
  const stateStore = useSelector(storeProductSelector);
  const pupState = useSelector(pupSelector);
  const { dataDelete } = pupState;
  const [showPreview, setShowPreview] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [tab, setTab] = useState(1);
  const handleChangeTabs = (key) => {
    setTab(key);
  };
  useEffect(() => {
    return () => dispatch(resetState());
  }, []);
  const handleDelete = () => {
    dispatch(deleteProduct(dataDelete.id));
    dispatch(setOpenPUDelete({ stateOpen: false, id: "", content: "" }));
  };
  const handleConfirm = () => {
    const data = {
      productId: stateStore.idProduct,
      status: t(stateStore.contentConfirm) === t("Còn hàng") ? 0 : 1,
    };
    dispatch(confirmStoreStatus(data));
  };

  return (
    <div className="wrapperStoreManager">
      {showPreview ? (
        <ModalPreviewProduct open={showPreview} setOpen={setShowPreview} />
      ) : null}
      {stateStore.isOpenModalAddProduct && (
        <ModalAddProduct title={"Thêm mới sản phẩm"} />
      )}
      {stateStore.isOpenModalEdit && <ModalEditProduct />}
      {stateStore.isOpenModalConfirm && (
        <ModalConfirmStoreStatus
          handleConfirm={handleConfirm}
          width={600}
          content={stateStore.contentConfirm}
        />
      )}
      {dataDelete.isOpenPUDelete && (
        <ModalDelete
          handleDelete={handleDelete}
          width={600}
          content="Bạn có đồng ý xóa sản phẩm này không?"
        />
      )}
      {stateStore.isOpenModalGetLog && (
        <ModalGetLog
          open={stateStore.isOpenModalGetLog}
          setOpen={setOpenModalGetLogStore}
          data={stateStore.dataLog}
        />
      )}
      <Notify
        isNotify={stateStore.isNotify}
        reset={resetStatus}
        title={"Bkav Pro"}
        content={stateStore.msg}
        type={stateStore.typeNotify}
      />
      <Row className="headerPage">
        <h2 className="title">
          <TranslateText text={"Quản lý cửa hàng Bkav"} />
        </h2>
      </Row>
      <Row>
        <Tabs
          key={1}
          activeKey={tab}
          onChange={handleChangeTabs}
          items={[
            {
              label: t("Tất cả"),
              key: 1,
              children: <TableStore setShowPreview={setShowPreview} />,
            },
            {
              label: t("Trang 1"),
              key: 2,
              children: <TableConfigPageOneStore />,
            },
          ]}
        />
      </Row>
    </div>
  );
};

export default StoreManager;
